import React, { useState } from "react";
import api, { brl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Copy, MessageCircle, FileText, CheckCircle2, Clock } from "lucide-react";
import { toast } from "sonner";
import { ComunicarClienteDialog } from "@/components/ComunicarClienteDialog";

export const AcordoLinkDialog = ({ acordo, onClose }) => {
  const [comunicar, setComunicar] = useState(false);
  if (!acordo) return null;
  const url = `${window.location.origin}/acordo/${acordo.sign_token}`;
  const assinado = !!acordo.assinatura;
  const copy = async () => { await navigator.clipboard.writeText(url).catch(() => {}); toast.success("Link copiado!", { description: url }); };
  const pdf = async () => {
    try { const r = await api.get(`/acordos/${acordo.id}/pdf`, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); }
    catch { toast.error("Erro ao gerar termo"); }
  };
  if (comunicar) return <ComunicarClienteDialog contexto="acordo" acordoId={acordo.id} clienteId={acordo.cliente_id} onClose={() => setComunicar(false)} />;
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="acordo-link-dialog">
        <DialogHeader>
          <DialogTitle className="break-words">Termo de Acordo — {acordo.cliente_nome}</DialogTitle>
          <DialogDescription>{acordo.num_parcelas}x • total {brl(acordo.total)}. Envie o link para o cliente assinar digitalmente.</DialogDescription>
        </DialogHeader>
        <div className={`flex items-start gap-2 text-sm rounded-lg px-3 py-2 ${assinado ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`} data-testid="acordo-status">
          {assinado ? <><CheckCircle2 className="w-4 h-4 shrink-0 mt-0.5" /><span className="break-words">Assinado por {acordo.assinatura.nome} (IP {acordo.assinatura.ip})</span></> : <><Clock className="w-4 h-4 shrink-0 mt-0.5" /> Aguardando assinatura do cliente</>}
        </div>
        <div className="text-xs bg-slate-50 border rounded-lg px-3 py-2 break-all mono" data-testid="acordo-link-url">{url}</div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          <Button variant="outline" onClick={copy} className="gap-1" data-testid="acordo-copy-link"><Copy className="w-4 h-4" /> Copiar</Button>
          <Button onClick={() => setComunicar(true)} className="gap-1 bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="acordo-whats-link"><MessageCircle className="w-4 h-4" /> Compartilhar</Button>
          <Button variant="outline" onClick={pdf} className="gap-1" data-testid="acordo-pdf-btn"><FileText className="w-4 h-4" /> Termo PDF</Button>
        </div>
        <DialogFooter><Button variant="ghost" onClick={onClose}>Fechar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
